import styled from 'styled-components';
import {  Dialog, } from 'cdk-radial';


export const MultiViewWidgetContainer = styled.div.attrs({ tabIndex: 0 })`
    background: ${({ theme }) => (theme.darkMode ? '#1A1A1A' : 'white')};
    backdrop-filter: blur(3px);
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid ${({ theme }) => (theme.darkMode ? '#333333' : '#e6e6e6')};
    border-radius: ${({ theme }) => theme.carbon.element.card.border.radius};
`;

export const MultiViewWidgetHeader = styled.div.attrs({ tabIndex: 0 })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 12px;
    padding: 12px;
    border-bottom: 1px solid ${({ theme }) => (theme.darkMode ? '#333333' : '#e6e6e6')};
`;


export const WidgetSettingDialog = styled(Dialog)`
  font-family: 'Roboto', 'Montserrat',  sans-serif;
  max-width: 60%;
  min-width: 40vw;
  border: 0;
  padding: 0;
  margin: 0;
  border: 1px solid rgb(128, 128, 128);
  @media (max-width: 1400px) {
    min-width: 400px;
  }
  @media (max-width: 470px) {
    max-width: 90%;
    width: 90vw;
    min-width: 90vw;
  }
`;

export const WidgetFilterDialog = styled(WidgetSettingDialog)`
  width: auto;
  
  > div[class*="DialogContent"] {
    overflow: visible;
  }
`;

export const WidgetContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  @media (max-width: 950px) {
    grid-template-columns: 1fr; 
  }
`;

export const CAWidgetContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;

  @media (max-width: 950px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 530px) {
    grid-template-columns: 1fr; 
  }
`;
